import taskManagerApi from "@/features/shared/services/taskManagerApi";
const extractErrorMessage = (error, fallback) => {
    if (error instanceof Error) {
        const serverError = error?.response?.data?.error;
        return serverError?.details ?? serverError?.message ?? error.message;
    }
    return fallback;
};
export const fetchCustomFields = async (activeOnly) => {
    try {
        const response = await taskManagerApi.get("/custom-fields", {
            params: {
                entity: "task",
                ...(activeOnly ? { active: true } : {}),
            },
        });
        const payload = response.data?.data;
        return payload?.fields ?? [];
    }
    catch (error) {
        throw new Error(extractErrorMessage(error, "Impossible de récupérer les champs personnalisés."));
    }
};
export const createCustomField = async (payload) => {
    try {
        const response = await taskManagerApi.post("/custom-fields", payload);
        return response.data?.data?.field ?? response.data?.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error, "Impossible de créer le champ personnalisé."));
    }
};
export const updateCustomField = async (id, payload) => {
    try {
        const response = await taskManagerApi.put(`/custom-fields/${id}`, payload);
        return response.data?.data?.field ?? response.data?.data;
    }
    catch (error) {
        throw new Error(extractErrorMessage(error, "Impossible de mettre à jour le champ personnalisé."));
    }
};
export const deleteCustomField = async (id) => {
    try {
        await taskManagerApi.delete(`/custom-fields/${id}`);
    }
    catch (error) {
        throw new Error(extractErrorMessage(error, "Impossible de supprimer le champ personnalisé."));
    }
};
